import request from 'utils/request'

export const getMCAXS691InitRequest = () =>
  request({
    url: '/MCAXS691/init',
    method: 'post',
  })
